/**
 * NotFoundPage – 404 stranica za nepostojeće adrese
 *
 * Prikazuje poruku i dugmad "Назад на почетну" i "Пријави се".
 */
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { EkonsultacijeButton } from '../ui/Button';
import { EkonsultacijeCard, EkonsultacijeCardContent } from '../ui/Card';
import { usePageTitle } from '../../context/PageTitleContext';
import { useAuth } from '@/shared/context/AuthContext';
import './ErrorPage.css';
import './NotFoundPage.css';

const NotFoundPage = () => {
  const navigate = useNavigate();
  const { updateTitle } = usePageTitle();
  const { login } = useAuth();

  useEffect(() => {
    updateTitle('Страница није пронађена - ОГП Портал', 'Страница није пронађена');
  }, [updateTitle]);

  const handleGoHome = () => {
    navigate('/');
  };

  const handleLogin = () => {
    login();
  };

  // ---------- Render ----------
  return (
    <div className="error-page not-found-page">
      <div className="container-fluid">
        <div className="error-page-content">
          <EkonsultacijeCard className="error-card">
            <EkonsultacijeCardContent>
              <div className="error-content">
                <div className="error-code">404</div>
                <h1 className="error-title">Страница није пронађена</h1>
                <p className="error-message">
                  Страница коју тражите не постоји или је премештена.
                </p>
                <div className="error-actions">
                  <EkonsultacijeButton
                    variant="primary"
                    size="lg"
                    onClick={handleGoHome}
                    className="error-button"
                  >
                    Назад на почетну
                  </EkonsultacijeButton>
                  <EkonsultacijeButton
                    variant="primary"
                    size="lg"
                    onClick={handleLogin}
                    className="error-button"
                  >
                    Пријави се
                  </EkonsultacijeButton>
                </div>
              </div>
            </EkonsultacijeCardContent>
          </EkonsultacijeCard>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;

